import { useEffect } from "react";
import { useScript } from "usehooks-ts";
import { useAppSelector } from "../../../redux/hooks";

/**
 * As per https://www.getbeamer.com/docs/#parameters
 */
type BeamerConfig = {
  // Basic parameters.
  product_id: string;
  selector: string;

  // Display parameters.
  display?: string;
  display_position?: string;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  embed?: boolean;
  button?: boolean;
  button_position?: string;
  icon?: string;
  bounce?: boolean;
  notification_prompt?: string;
  notification_prompt_delay?: number;
  nps_delay?: number;
  ignore_boosted_announcements?: boolean;

  //Filter parameters.
  language?: string;
  filter?: string;
  force_filter?: string;
  filter_by_url?: boolean;
  mobile?: boolean;
  lazy?: boolean;
  alert?: boolean;
  force_button?: boolean;
  counter?: boolean;
  first_visit_unread?: number;
  standalone?: boolean;
  post_request?: boolean;
  delay?: number;

  // Function parameters. Signature might be typed wrond, consult the docs and refine
  callback?: () => void;
  onclick?: () => void;
  onopen?: () => void;
  onclose?: () => void;
  onerror?: () => void;
  onNpsShow?: () => void;
  onNpsHide?: () => void;
  onNpsScore?: () => void;
  onNpsFeedback?: () => void;
  forceShowNPS?: () => void;
  onInputFocus?: () => void;
  onInputBlur?: () => void;

  user_firstname?: string;
  user_lastname?: string;
  user_email?: string;
  user_id?: string;
  multi_user?: boolean;
  user_created_at?: number | string;
};

declare global {
  interface Window {
    Beamer?: {
      init: () => void;
      update: (data: Partial<BeamerConfig>) => void;
      destroy: () => void;
    };
    beamer_config: BeamerConfig;
  }
}

const BeamerInAppNotifications = () => {
  const status = useScript("https://app.getbeamer.com/js/beamer-embed.js");
  const user = useAppSelector((state) => state.user);

  useEffect(() => {
    window.beamer_config = {
      product_id: "DJnlwoxR39180",
      lazy: true,
      selector: ".beamerButton",
    };
  }, []);

  useEffect(() => {
    if (status === "ready") {
      window.Beamer?.init();
    }

    return () => {
      window.Beamer?.destroy();
    };
  }, [status]);

  useEffect(() => {
    if (user.user_id && !user.is_staff && status === "ready") {
      window.Beamer?.update({ user_id: user.user_id });
    }
  }, [user, status]);

  return null;
};

export default BeamerInAppNotifications;
